<mat-dialog-content class="modal">
  <h3>Großanlagen ab 10 MW – bitte kontaktieren Sie uns direkt</h3>
  <p>
    Die von Ihnen angegebene Anlagengröße liegt über 10 MW. Für größere Anlagen erstellen wir Ihnen
    ein individuelles Direktvermarktungsangebot.
  </p>

  <p>
    Bitte laden Sie unser Datenblatt herunter, füllen Sie es aus und senden Sie es per E-Mail an 
    <a href="mailto:{{ contactEmail() }}" target="_blank" class="blue-url">{{ contactEmail() }}</a
    >. Wir prüfen Ihre Angaben individuell und setzen uns zeitnah mit Ihnen in Verbindung.
  </p>

  <p>
    👉
    <a
      href="/documents/2025_EnBW_Stammdatentemplate_Direktvermarktung-Indikation_Wind_PV.xltx"
      target="_blank"
      class="blue-url"
      >[<u>Datenblatt herunterladen</u>]</a
    >
  </p>
  <p>Vielen Dank – wir freuen uns auf Ihre Anfrage.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="modal-button" (click)="closeDialog()">Schließen</button>
</mat-dialog-actions>
